export enum StaticApplicationId {
  authentication = '',
  praise = '6258E8CD-F2FB-429E-AE16-1C01C3F633A8',
  communication = '709CF739-3D63-4ACE-BCA2-722A6401E8EE',
  myworkspace = '5555C35C-5B5C-441B-9D92-34C3B34CD13D',
  digitalObeya = 'BCE987A3-58DD-4830-B9E4-08A9DE7A0A07',
  digitalObeyaRevamp = 'D0B2FA54-9B7E-45CC-B3AF-F4236FC0BE4A',
  posts = '655EC1FF-9A03-43A4-8EF8-D035F4DD8EAC',
  survey = '41CE2D11-957D-40F9-9D3E-9BAF32496CDF',
  users = 'CB9FF60D-44A6-4B01-8461-CB797FB80FF2',
  rca = 'E4878F2F-9A3C-4114-AB94-31B6A04C022A',
  bos = 'E7E53D89-96D5-474D-AB7C-CAC76EE99F62',
  quiz = '7A58FFEB-E343-451F-AA32-BE7735A95FEC',
  alert = '8B5B3C53-7A21-4A1D-AA02-CDCB068D9C48',
  multilingual = '63FDFFA2-19E6-42D5-977B-BB5F734B06BD',
  general = '9D306CEF-9C6B-416A-A077-82E295EDDF53',
  administration = '78A4AB44-CABD-42D9-8C31-7AD28EE48514',
  feed = 'E07E98AE-9978-4C93-B787-1D961F7FE2E6',
  unsafeCondition = 'CE583F03-E4D5-498E-8D20-593C7169790A',
  projects = '53BB8463-C21C-4D2A-A8AB-EBCB5A802DEB',
  kaizen = 'F232DDBA-C1C9-4BE1-9B49-FFDE33E63F1B',
  defectTag = '91AEE4DC-03CF-4A39-BFE4-5BDFBF161E31',
  actionPlan = '85AF27F3-2FBB-46A1-AECE-2460C22EB14A',
  actionPlanCore = '85AF27F3-2FBB-46A1-AECE-2460C22EB14A',
  actionPlanRevamp = '572F2B9F-FAE1-4A3D-A21D-8E8D72EA0289',
  copilot = ' ',
  lpp = 'DCCC2AFC-8B5A-4EE9-A1E6-46425FFB740F',
  scorecard = '5250D6F1-6E5C-4A57-A62B-2BA460956B07',
  training = 'D69CD5A4-1F73-40F2-B4A7-50D8BF8B0A10',
  lil = '1CE147DD-5EF2-498A-841F-D2E1D8AFB242',
  lilRevamp = 'C17F5628-4D0C-416B-BCF5-B8AE4568EC17',
  myApprovals = 'F4C34D95-21DE-4AD1-B501-664DD5636F71',
  whywhy = '  ',
  incident = '724B7CD8-2DCD-4441-960F-EE79AEAEEDC4',
  complaint = '05F8C1DF-A1AD-4F6C-800D-1F0B6CF84104',
  nonconformity = '5E43B55C-11A5-49A9-83B5-99C919D8E481',
  rcaLegacy = '469494BE-C7E2-4DA1-8A43-C9BE6B68B0ED',
  lppLegacy = '6F0234AA-49CE-4FFB-B1A9-AC8F1F507875',
  defectTagLegacy = 'EE2159DE-9D30-41DA-A213-18984790C824',
  bosLegacy = '5584AE33-331E-4C89-8FE8-569ED7AC3733',
  unsafeConditionLegacy = '79F3ECF2-57F7-412E-80A0-7CF04172CBCF',
  alertLegacy = 'C7275610-3233-4D97-9829-F8ACB9AC0B3E',
  personalBook = '3F807109-D34A-4688-A825-724CC527F41B',
  documentationCore = 'FA0CDEC7-5733-4D25-8743-1B61794ADB3C',
  knowledgeCenter = '6C4B9BD5-A491-4AD5-A33C-0FD0A24F1DCA',
}
